import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL, USER_SERVICE_URL } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import ReactTable from "react-table";
// @ts-ignore
import Rodal from "rodal";
import Regions from "../../components/Global/regions";
import { withRouter } from "react-router";
var qs = require("qs");
var UserList = /** @class */ (function (_super) {
    tslib_1.__extends(UserList, _super);
    function UserList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            searching: false,
            users: [],
            page: _this.props.history.location.search.split('=')[1] ? Number(_this.props.history.location.search.split('=')[1]) - 1 : 0,
            pageSize: 20,
            loading: true,
            currentUser: {},
            showRodal: false,
            query: '',
            filterIds: '',
            sort: '-user_id',
            report: false,
            region: 'all',
        };
        return _this;
    }
    UserList.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.history.action === "POP") {
            var prevState = localStorage.getItem("users-state");
            if (prevState) {
                var parsePrevState = JSON.parse(prevState);
                this.setState(tslib_1.__assign({}, parsePrevState, { page: this.props.history.location.search.split('=')[1] }), function () {
                    _this.getUsers();
                });
            }
            else {
                this.getUsers();
            }
        }
        else {
            this.getUsers();
        }
        localStorage.removeItem("users-state");
    };
    UserList.prototype.componentWillUnmount = function () {
        console.log(this.state.dateFrom);
        localStorage.setItem("users-state", JSON.stringify({
            filterIds: this.state.filterIds,
            page: this.state.page,
            pageSize: this.state.pageSize,
            query: this.state.query,
        }));
    };
    UserList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.props.history.action === "POP") {
            this.setState({ page: this.props.history.location.search.split('=')[1] }, function () {
                _this.getUsers();
            });
        }
    };
    UserList.prototype.render = function () {
        var _this = this;
        var columns = [{
                Header: '#',
                accessor: 'user_id',
                width: 100,
                style: { textAlign: 'center' }
            }, {
                Header: 'ФИО',
                accessor: 'fio',
            }, {
                Header: 'Управление',
                sortable: false,
                width: 150,
                style: { textAlign: 'center' },
                Cell: function (props) {
                    return (React.createElement("div", { className: "btn-group" },
                        React.createElement("button", { onClick: _this.viewUser.bind(_this, props.row._original), className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-eye" })),
                        React.createElement("button", { onClick: _this.removeUser.bind(_this, props.row._original.id), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-trash" }))));
                }
            }];
        return (React.createElement(React.Fragment, null,
            React.createElement(Rodal, { onClose: function () {
                    _this.setState({ showUser: false, currentUser: {} });
                }, visible: this.state.showUser, width: 400, height: 'auto' },
                React.createElement("img", { src: this.state.currentUser.avatar }),
                React.createElement("br", null),
                "\u0418\u043C\u044F: ",
                this.state.currentUser.name,
                React.createElement("br", null),
                "\u0424\u0430\u043C\u0438\u043B\u0438\u044F: ",
                this.state.currentUser.surname,
                React.createElement("br", null),
                "\u041E\u0442\u0447\u0435\u0441\u0442\u0432\u043E: ",
                this.state.currentUser.patronymic,
                React.createElement("br", null),
                "E-Mail: ",
                this.state.currentUser.email,
                React.createElement("br", null),
                "\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C: ",
                this.state.currentUser.post,
                React.createElement("br", null),
                "\u0420\u0430\u0431\u043E\u0442\u0430: ",
                this.state.currentUser.job,
                React.createElement("br", null),
                "\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C: ",
                this.state.currentUser.specialty,
                React.createElement("br", null),
                "\u0421\u0442\u0430\u0436 \u0440\u0430\u0431\u043E\u0442\u044B \u043F\u043E \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438: ",
                this.state.currentUser.experience,
                React.createElement("br", null),
                "\u041D\u0430\u0443\u0447\u043D\u0430\u044F \u0441\u0442\u0435\u043F\u0435\u043D\u044C: ",
                this.state.currentUser.science_degree,
                React.createElement("br", null),
                "\u0420\u0430\u0431\u043E\u0442\u0430 \u0432 \u043E\u0431\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445, \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u043D\u044B\u0445 \u0441\u043E\u0432\u0435\u0442\u0430\u0445: ",
                this.state.currentUser.council_work,
                React.createElement("br", null),
                "\u0413\u043E\u0440\u043E\u0434: ",
                this.state.currentUser.location_name,
                React.createElement("br", null),
                "\u0420\u0435\u0433\u0438\u043E\u043D: ",
                this.state.currentUser.region_fias,
                React.createElement("br", null),
                "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F: ",
                this.state.currentUser.bdate,
                React.createElement("br", null),
                "\u0421\u0435\u043C\u0435\u0439\u043D\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441: ",
                this.state.currentUser.family_status,
                React.createElement("br", null),
                "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0434\u043E\u0445\u043E\u0434\u0430: ",
                this.state.currentUser.income_level,
                React.createElement("br", null)),
            React.createElement(Rodal, { onClose: function () {
                    _this.setState({ showRodal: false, currentUser: {} });
                }, visible: this.state.showRodal, width: 400, height: 400 },
                React.createElement("div", { className: "form-group" },
                    "\u0424\u0430\u043C\u0438\u043B\u0438\u044F",
                    React.createElement("input", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "surname", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState(function (prevState) {
                                var cc = prevState.currentUser;
                                cc.surname = value;
                                return { currentUser: cc };
                            });
                        }, value: this.state.currentUser.surname, type: "text" })),
                React.createElement("div", { className: "form-group" },
                    "\u0418\u043C\u044F",
                    React.createElement("input", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "name", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState(function (prevState) {
                                var cc = prevState.currentUser;
                                cc.name = value;
                                return { currentUser: cc };
                            });
                        }, value: this.state.currentUser.name, type: "text" })),
                React.createElement("div", { className: "form-group" },
                    "\u041E\u0442\u0447\u0435\u0441\u0442\u0432\u043E",
                    React.createElement("input", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "patronymic", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState(function (prevState) {
                                var cc = prevState.currentUser;
                                cc.patronymic = value;
                                return { currentUser: cc };
                            });
                        }, value: this.state.currentUser.patronymic, type: "text" })),
                React.createElement("button", { type: 'button', onClick: this.updateUser.bind(this), className: "btn btn-primary btn-lg btn-block", style: { color: '#fff' } }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    React.createElement("h3", null, "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438")),
                React.createElement("div", { className: "form-group" },
                    "ID",
                    React.createElement("input", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "id", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState({
                                filterIds: value,
                            }, function () { return _this.getUsers(); });
                        }, value: this.state.filterIds, type: "text" })),
                React.createElement("div", { className: "form-group" },
                    "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0441\u043B\u043E\u0432\u0430\u043C",
                    React.createElement("input", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "query", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState({
                                query: value,
                            }, function () { return _this.getUsers(); });
                        }, value: this.state.query, type: "text" })),
                React.createElement("div", { className: "form-group" },
                    "\u041F\u043E \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438",
                    React.createElement("select", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "region", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState({
                                region: value,
                            }, function () { return _this.getUsers(); });
                        }, value: this.state.region },
                        React.createElement("option", { value: 'all' }, "\u0412\u0441\u0435"),
                        React.createElement("option", { value: 'dv' }, "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0414\u0430\u043B\u044C\u043D\u0435\u0432\u043E\u0441\u0442\u043E\u0447\u043D\u043E\u0433\u043E \u0424\u041E"),
                        React.createElement("option", { value: 'notdv' }, "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0440\u0435\u0433\u0438\u043E\u043D\u043E\u0432 \u0420\u0424"))),
                React.createElement("div", { className: 'col col-md-2 text-right' },
                    React.createElement("button", { onClick: this.getReport.bind(this), type: 'button', disabled: this.state.report, className: 'btn btn-success btn-search ' + (this.state.report ? 'disabled' : '') }, this.state.report ? 'Ожидайте...' : 'Выгрузить EXCEL'))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(ReactTable, { previousText: '\u041D\u0430\u0437\u0430\u0434', nextText: '\u0412\u043F\u0435\u0440\u0435\u0434', loadingText: 'Loading...', noDataText: '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', pageText: '\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430', ofText: '\u0438\u0437', rowsText: '\u0441\u0442\u0440\u043E\u043A', page: this.state.page, pages: Math.ceil(this.state.pages / this.state.pageSize), loading: this.state.loading, minRows: 1, manual: true, onPageChange: this.nextPage.bind(this), onSortedChange: this.onSort.bind(this), onPageSizeChange: this.onPageSize.bind(this), data: this.state.users, columns: columns })))));
    };
    UserList.prototype.getUsers = function () {
        var _this = this;
        this.setState({ loading: true });
        var searchString = 'page=' + (this.state.page + 1) + '&sort=' + this.state.sort + '&limit=' + this.state.pageSize;
        searchString += '&ids=' + this.state.filterIds + '&query=' + this.state.query + '&region=' + this.state.region;
        axios.get(API_URL + '/users?' + searchString, {
            headers: { 'Authorization': this.props.auth_token }
        }).then(function (resp) {
            _this.setState({
                users: resp.data.data ? resp.data.data : [], pages: resp.data.meta.total,
                loading: false
            });
        }).catch(function (error) {
            if (error.response && error.response.status === 403) {
                toastr.error('Ошибка', 'У Вас недостаточно прав');
            }
        });
    };
    UserList.prototype.nextPage = function (page) {
        var _this = this;
        this.setState({ page: page }, function () {
            _this.getUsers();
            _this.addParamToUrl(page + 1);
        });
    };
    UserList.prototype.onSort = function (sort) {
        var _this = this;
        this.setState({ sort: sort[0].desc ? '-' + sort[0].id : sort[0].id }, function () { return _this.getUsers(); });
    };
    UserList.prototype.onPageSize = function (pageSize) {
        var _this = this;
        this.setState({
            pageSize: pageSize,
            page: 0,
        }, function () {
            _this.getUsers();
            _this.addParamToUrl(_this.state.page + 1);
        });
    };
    UserList.prototype.removeUser = function (id) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите удалить пользователя?');
        if (result) {
            axios.delete(API_URL + '/user/' + id, {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getUsers();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    /*private editUser(theme:any){
      this.setState({showRodal: true, currentUser: theme })
    }*/
    UserList.prototype.viewUser = function (user) {
        Regions.regions.forEach(function (r) {
            if (r.guid === user.region) {
                user.region_fias = r.name;
            }
        });
        this.setState({ showUser: true, currentUser: user });
    };
    UserList.prototype.updateUser = function () {
        var _this = this;
        if (this.state.currentUser.title.trim().length > 0) {
            axios.put(API_URL + '/user/' + this.state.currentUser.id, qs.stringify({
                name: this.state.currentUser.name,
                surname: this.state.currentUser.surname,
                patronymic: this.state.currentUser.patronymic,
            }), {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                toastr.success('Успех', 'Пользователь обновлен');
                _this.setState({ currentTheme: { title: '', id: null }, showRodal: false }, function () {
                    _this.getUsers();
                });
            }).catch(function (e) {
                if (e.response && e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response && (e.response.data.code === 406 || e.response.data.code === 409)) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    UserList.prototype.sleep = function (ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    };
    UserList.prototype.getReport = function () {
        var _this = this;
        var thisThis = this;
        var arrayIds = this.state.filterIds.split(",");
        var arrNum = [];
        arrayIds.forEach(function (a) {
            if (Number(a) > 0) {
                arrNum.push(a);
            }
        });
        this.setState({
            report: true,
        }, function () {
            var searchString = '';
            if (arrNum.length < 1) {
                searchString += '&dvs=true&ufilter=' + _this.state.region;
            }
            else {
                searchString += '&ids=' + arrNum.join(',');
            }
            axios.get(USER_SERVICE_URL + '/users/excel?token=' + _this.props.auth_token + searchString)
                .then(function (r) {
                if (r.data.code === 200) {
                    // @ts-ignore
                    function f() {
                        return tslib_1.__awaiter(this, void 0, void 0, function () {
                            var _loop_1, state_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _loop_1 = function () {
                                            var complete;
                                            return tslib_1.__generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, thisThis.sleep(10000)];
                                                    case 1:
                                                        _a.sent();
                                                        complete = false;
                                                        axios.get(USER_SERVICE_URL + '/' + r.data.text + '&token=' + thisThis.props.auth_token).then(function (res) {
                                                            if (res.data.code === 201) {
                                                                complete = true;
                                                                thisThis.setState({
                                                                    report: false,
                                                                });
                                                                window.open(USER_SERVICE_URL + '/' + res.data.text + '&token=' + thisThis.props.auth_token);
                                                            }
                                                        }).catch(function (err) {
                                                            console.log(err);
                                                            complete = true;
                                                            thisThis.setState({
                                                                report: false,
                                                            }, function () {
                                                                alert('Не удалось сформировать выгрузку');
                                                            });
                                                        });
                                                        return [4 /*yield*/, thisThis.sleep(1000)];
                                                    case 2:
                                                        _a.sent();
                                                        if (complete) {
                                                            return [2 /*return*/, "break-labelCancelWhile"];
                                                        }
                                                        return [2 /*return*/];
                                                }
                                            });
                                        };
                                        _a.label = 1;
                                    case 1:
                                        if (!true) return [3 /*break*/, 3];
                                        return [5 /*yield**/, _loop_1()];
                                    case 2:
                                        state_1 = _a.sent();
                                        switch (state_1) {
                                            case "break-labelCancelWhile": return [3 /*break*/, 3];
                                        }
                                        return [3 /*break*/, 1];
                                    case 3:
                                        ;
                                        return [2 /*return*/];
                                }
                            });
                        });
                    }
                    f();
                }
            }).catch(function (e) {
                console.log(e);
                _this.setState({
                    report: false,
                }, function () {
                    alert('Не удалось сформировать выгрузку');
                });
            });
        });
    };
    UserList.prototype.addParamToUrl = function (param) {
        var url = '?page=' + param;
        this.props.history.push(url);
        return true;
    };
    return UserList;
}(React.Component));
export default withRouter(connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(UserList));



//////////////////
// WEBPACK FOOTER
// ./src/views/users/index.tsx
// module id = 532
// module chunks = 0